import React, { useState, useEffect } from "react";
import { useFormik, FieldArray, FormikProvider, Form, replace } from "formik";
import * as Yup from "yup";
import Image from "../../assets/img/OnboardImg.png";
import { useNavigate } from "react-router-dom";

// Importing sweet alert modal pop-up
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

// Importing Redux's
import { useDispatch, useSelector } from "react-redux";
import {
  SET_ONBOARD_SLIDE_2_DATA,
  SET_ONBOARD_SLIDE_3_DATA,
  LOGIN
} from "../../redux/constants/index";
import {
  submittingOnboard,
  addTeamsOnboarding,
  addUsersOnboarding,
  addToDoOnboarding,
  addAssetsOnboarding,
  completeOnboardingProcess,
  updateStripeCustomer
} from "../../redux/actions/onboarding";
import { getDepartment } from "../../redux/actions/department";
import { getUser } from "../../redux/actions/user";
import { getActivityDataForOnboarding } from "../../redux/actions/todo";

// Importing Onboarding Component
import OnboadingFooter from "./OnboadingFooter";
import OnboardingSlide1 from "./OnboardingSlide1";
import OnboardingSlide2 from "./OnboardingSlide2";
import OnboardingSlide3 from "./OnboardingSlide3";
import OnboardingSlide4 from "./OnboardingSlide4";
import OnboardingSlide5 from "./OnboardingSlide5";
import OnboardingSlide6 from "./OnboardingSlide6";
import OnboardingSlide7 from "./OnboardingSlide7";
import OnboardingSlide8 from "./OnboardingSlide8";
import OnboardingSlide9 from "./OnboardingSlide9";

export default function Onboading() {
  const [page, setPage] = useState(1);
  const [activityData, setActivityData] = useState([]);
  const navigate = useNavigate();

  // Managing error state to show error messages
  const [errorForSlide2, setErrorForSlide2] = useState(false);
  const [errorForSlide3Country, setErrorForSlide3Country] = useState(false);
  const [errorForSlide3BusinessType, setErrorForSlide3BusinessType] =
    useState(false);
  const [errorForSlide3Gst_number, SeterrorForSlide3Gst_number] =
    useState(false);
  const [errorForSlide4, setErrorForSlide4] = useState(false);
  const [errorForSlide5, setErrorForSlide5] = useState(false);
  const [errorForSlide6, setErrorForSlide6] = useState(false);
  const [errorForSlide7, setErrorForSlide7] = useState(false);

  // Creating State to setup initial value on formik
  const [teamsFormikInitialvalue, setTeamsFormikInitialvalue] = useState([
    {
      team_name: null,
      timezone_id: null,
    },
  ]);
  const [userFormikInitialValue, setUserFormikInitialValue] = useState([
    {
      first_name: null,
      last_name: null,
      email: null,
      team_name: null,
    },
  ]);

  const dispatch = useDispatch();
  const { slider_2_Data, slider_3_Data, slider_4_Data } = useSelector(
    (state) => state.onboarding
  );
  const user = useSelector((state) => state.auth);
  const { departmentList } = useSelector((state) => state.department);
  const { userList } = useSelector((state) => state.user);
  const { activityDataForOnboarding } = useSelector((state) => state.todo);

  /*----------------- API calling to get stored teams, users and todos ------------------ */
  const getTeamsData = () => {
    dispatch(
      getDepartment((res) => {
        if (res.status === 0) {
          swal({
            content: (
              <CustomeModal type="error" title="Error!" content={res.message} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      })
    );
  };

  const getUserData = () => {

    const request = {
      onSuccess: (res) => {
      },
      onError: (error) => {
       swal({
          content: (
            <CustomeModal type="error" title="Error!" content={error.message} />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(getUser(request));
  };

  const getActivityData = () => {
    dispatch(
      getActivityDataForOnboarding((res) => {
        if (res.status === 0) {
          swal({
            content: (
              <CustomeModal type="error" title="Error!" content={res.message} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      })
    );
  };

  useEffect(() => {
    if (user?.is_board_complete && !user?.is_subscribed) {
      setPage(8);
    }
  }, []);

  useEffect(() => {
    if (page === 4) {
      getTeamsData();
    } else if (page === 5) {
      getUserData();
    } else if (page === 6) {
      getActivityData();
    }
  }, [page]);

  /*--------------------------------- Setting InitialValue ------------------------------ */
  useEffect(() => {
    if (departmentList.length > 0) {
      const arr = [];
      departmentList.map((team) => {
        const teamsObj = {
          id: team.id,
          team_name: team.name,
          timezone_id: {
            label: team.time_zone,
            value: team.timezone_id,
          },
        };
        arr.push(teamsObj);
      });
      setTeamsFormikInitialvalue(arr);
    }
  }, [departmentList]);

  useEffect(() => {
    if (userList.data.length > 1) {
      const arr = [];
      userList.data.filter((item) => item.type === "user")
        .map((user) => {
          const obj = {
            id: user.id,
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            team_name: user.departments.map((department) => {
              const teamsObj = { label: department.name, value: department.id };
              return teamsObj;
            }),
          };
          arr.push(obj);
        });
      setUserFormikInitialValue(arr);
    } else {
      setUserFormikInitialValue([
        { first_name: null, last_name: null, email: null, team_name: null },
      ]);
    }
  }, [userList]);

  useEffect(() => {
    if (activityDataForOnboarding.length > 0) {
      const arr = [];
      activityDataForOnboarding.map((item, index) => {
        const obj = {
          activity_id: item,
          team_name: item.department,
          user_name: item.user,
        };
        arr.push(obj);
      });
      setActivityData(arr);
    } else {
      setActivityData([]);
    }
  }, [activityDataForOnboarding]);

  /* --------------- Adding Validation for Onboarding Slider 2 ----------------- */
  const validationSchemaForSlide2 = Yup.object().shape({
    first_name: Yup.string()
      .min(3, "First name should have atleast 3 character long")
      .max(30, "First name cannot be more than 30 character long")
      .matches(/^[^\s][\p{L} '-]+$/u, "Invalid first name")
      .required("This field is required"),
    last_name: Yup.string()
      .min(3, "Last name should be atleast 3 character long")
      .max(30, "Last name cannot be more than 30 character long")
      .matches(/^[^\s][\p{L} '-]+$/u, "Invalid last name")
      .required("This field is required"),
    mobile_number: Yup.string()
      .min(7, "Mobile number should have a minimum of 7 digits")
      .max(15, "Mobile number should have a maximum of 15 digits")
      .matches(/^\d+$/, "Enter valid mobile number"),
  });

  const formik_for_slide_2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name:
        Object.keys(slider_2_Data).length > 0 ? slider_2_Data.first_name : "",
      last_name:
        Object.keys(slider_2_Data).length > 0 ? slider_2_Data.last_name : "",
      mobile_number:
        Object.keys(slider_2_Data).length > 0
          ? slider_2_Data.mobile_number
          : "",
      time_zone:
        Object.keys(slider_2_Data).length > 0 ? slider_2_Data.time_zone : null,
    },
    validationSchema: validationSchemaForSlide2,
    onSubmit: () => {
      if (formik_for_slide_2.values.time_zone) {
        dispatch({
          type: SET_ONBOARD_SLIDE_2_DATA,
          payload: formik_for_slide_2.values,
        });
        user.first_name = formik_for_slide_2.values.first_name;
        user.last_name = formik_for_slide_2.values.last_name;
        user.name = formik_for_slide_2.values.first_name + " " + formik_for_slide_2.values.last_name
        localStorage.setItem("user", JSON.stringify(user));
        setPage(page + 1);
      } else {
        setErrorForSlide2(!errorForSlide2);
      }
    },
  });

  /* ------------------- Adding Validation for Onboarding Slider 3 ----------------- */
  const formik_for_slide_3 = useFormik({
    enableReinitialize: true,
    initialValues: {
      country_name:
        Object.keys(slider_3_Data).length > 0
          ? slider_3_Data.country_name
          : null,
      tax_id: Object.keys(slider_3_Data).length > 0 ? slider_3_Data.tax_id : "",
      business_type:
        Object.keys(slider_3_Data).length > 0
          ? slider_3_Data.business_type
          : null,
      employee_number:
        Object.keys(slider_3_Data).length > 0
          ? slider_3_Data.employee_number
          : "",
    },
    onSubmit: () => {
      if (
        formik_for_slide_3.values.country_name &&
        formik_for_slide_3.values.business_type &&
        formik_for_slide_3.values.tax_id
      ) {
        dispatch({
          type: SET_ONBOARD_SLIDE_3_DATA,
          payload: formik_for_slide_3.values,
        });
        handle_slide_2_and_3_data();
      } else if (
        formik_for_slide_3.values.country_name &&
        !formik_for_slide_3.values.business_type &&
        formik_for_slide_3.values.tax_id
      ) {
        setErrorForSlide3BusinessType(true);
      } else if (
        !formik_for_slide_3.values.country_name &&
        formik_for_slide_3.values.business_type &&
        formik_for_slide_3.values.tax_id
      ) {
        setErrorForSlide3Country(true);
      } else if (
        !formik_for_slide_3.values.tax_id &&
        formik_for_slide_3.values.business_type &&
        formik_for_slide_3.values.country_name
      ) {
        SeterrorForSlide3Gst_number(true);
      } else {
        setErrorForSlide3Country(true);
        setErrorForSlide3BusinessType(true);
        SeterrorForSlide3Gst_number(true);
      }
    },
  });

  /* --------------------- Adding Validation for Onboarding Slider 4 ------------- */
  const formik_for_slide_4 = useFormik({
    enableReinitialize: true,
    initialValues: {
      teamData: teamsFormikInitialvalue,
    },
  });

  const formik_for_slide_4_onSubmit = () => {
    const arr = [];
    formik_for_slide_4.values.teamData.map((item, index) => {
      const obj = {};
      if (
        item.team_name !== null &&
        item.team_name !== "" &&
        item.timezone_id
      ) {
        if (item.id) {
          obj["id"] = item.id;
          obj["name"] = item.team_name;
          obj["timezone_id"] = item.timezone_id.value;
        } else {
          obj["name"] = item.team_name;
          obj["timezone_id"] = item.timezone_id.value; 
        }
        arr.push(obj);
      }
    });
    if (arr.length > 0) {
      handle_slide_4_data(arr);
    } else {
      setErrorForSlide4(!errorForSlide4);
    }
  };

  /*----------------------- Adding Validation for Onboarding Slider 5 --------------- */
  const formik_for_slide_5 = useFormik({
    enableReinitialize: true,
    initialValues: {
      userData: userFormikInitialValue,
    },
    onSubmit: async () => {
      const data = formik_for_slide_5.values.userData.filter(
        (item, index) =>
          !(
            item.first_name === "" ||
            item.first_name === null ||
            item.last_name === "" ||
            item.last_name === null ||
            item.email === "" ||
            item.email === null ||
            item.team_name === "" ||
            item.team_name === null ||
            item.team_name.length === 0
          )
      );
      if (data.length > 0) {
        handle_slide_5_data(data);
      } else {
        setErrorForSlide5(!errorForSlide5);
      }
    },
  });

  /* ----------------------- Adding Validation for Onboarding Slider 6 ------------------ */
  const addRemoveElement = (element) => {
    if (activityData.some((item) => item.activity_id.name === element.name)) {
      setActivityData(
        activityData.filter((item) => item.activity_id.name !== element.name)
      );
    } else {
      const newDataToAdd = {
        activity_id: element,
        team_name: null,
        user_name: null,
      };
      setActivityData([...activityData, newDataToAdd]);
    }
  };

  const formik_for_slide_6 = useFormik({
    enableReinitialize: true,
    initialValues: {
      toDoData: activityData,
    },
    onSubmit: () => {
      const data = formik_for_slide_6.values.toDoData.filter(
        (item) => item.team_name !== null
      );
      if (data.length > 0) {
        handle_slide_6_data(data);
      } else {
        setErrorForSlide6(!errorForSlide6);
      }
    },
  });

  /* ------------------- Validation for Slide 7 -------------------- */
  const formik_for_slide_7 = useFormik({
    enableReinitialize: true,
    initialValues: {
      Asset: [
        {
          company_id: user.company.id,
          asset_type: null,
          asset_type_Option: null,
        },
      ],
    },
    onSubmit: () => {
      const data = formik_for_slide_7.values.Asset.filter(
        (asset_Item) =>
          asset_Item.asset_type !== null &&
          asset_Item.asset_type !== "" &&
          asset_Item.asset_type_Option
      );
      if (data.length > 0) {
        handle_slide_7_data(data);
      } else {
        setErrorForSlide7(!errorForSlide7);
      }
    },
  });

  const send_formik_handleSubmit = () => {
    if (page === 2) {
      formik_for_slide_2.handleSubmit();
    } else if (page === 3) {
      formik_for_slide_3.handleSubmit();
    } else if (page === 4) {
      formik_for_slide_4_onSubmit();
    } else if (page === 5) {
      formik_for_slide_5.handleSubmit();
    } else if (page === 6) {
      formik_for_slide_6.handleSubmit();
    } else if (page === 7) {
      formik_for_slide_7.handleSubmit();
    }
  };

  const handlePreviousButtonClick = () => {
    if (page === 2) {
      setPage(page - 1);
    } else if (page === 3) {
      setPage(page - 1);
    } else if (page === 4) {
      setPage(page - 1);
    } else if (page === 5) {
      formik_for_slide_5.handleReset();
      setPage(page - 1);
    } else if (page === 6) {
      formik_for_slide_6.handleReset();
      setPage(page - 1);
    } else if (page === 7) {
      setPage(page - 1);
    }
  };

  /* -------- API calling for Slide 2 and Slide 3 --------- */

  const updateStripeCustomerAPI = () => {
    const request = {
      payload: {
        name: `${formik_for_slide_2.values.first_name.trim()} ${formik_for_slide_2.values.last_name.trim()}`,
        phone: formik_for_slide_2.values.mobile_number.trim()
          ? formik_for_slide_2.values.mobile_number.trim()
          : null,
        address: {
          country: formik_for_slide_3.values.country_name.value,
        },
      },
      stripe_customer_id: user.company?.stripe_customer_id
        ? user.company?.stripe_customer_id
        : "",
      onSuccess: () => {
        setPage(page + 1);
      },
      onError: () => {
        setPage(page + 1);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(updateStripeCustomer(request))
  };

  const handle_slide_2_and_3_data = () => {
    const request = {
      body: {
        country_code: formik_for_slide_3.values.country_name.value,
        first_name: formik_for_slide_2.values.first_name.trim(),
        last_name: formik_for_slide_2.values.last_name.trim(),
        country: formik_for_slide_3.values.country_name.label,
        company_name: user?.company?.name,
        employee_size: formik_for_slide_3.values.employee_number,
        business_type: formik_for_slide_3.values.business_type.label,
        mobile: formik_for_slide_2.values.mobile_number.trim(),
        time_zone_id: formik_for_slide_2.values.time_zone.value,
        tax_id: formik_for_slide_3.values.tax_id,
      },
      onSuccess: () => {
        updateStripeCustomerAPI()
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(submittingOnboard(request));
  };

  /* ---------- API calling for slide 4 ----------- */
  const handle_slide_4_data = (arr) => {
    const request = {
      body: {
        teams: arr,
      },
      onSuccess: () => {
        setPage(page + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(addTeamsOnboarding(request));
  };

  /* ------------ API calling for slide 5 --------------- */
  const handle_slide_5_data = (formikUserData) => {
    const payload = [];
    formikUserData.map((item) => {
      const obj = {};
      if (
        item.team_name !== null ||
        item.first_name !== null ||
        item.last_name !== null ||
        item.email !== null
      ) {
        if (item?.id) {
          obj["id"] = item.id;
          obj["first_name"] = item.first_name;
          obj["last_name"] = item.last_name;
          obj["email"] = item.email;
          obj["departments"] = item.team_name.map((element) => element.value);
          payload.push(obj);
        } else {
          obj["first_name"] = item.first_name;
          obj["last_name"] = item.last_name;
          obj["email"] = item.email;
          obj["departments"] = item.team_name.map((element) => element.value);
          payload.push(obj);
        }
      }
    });

    const request = {
      body: {
        adminName: slider_2_Data.first_name + " " + slider_2_Data.last_name,
        companyName: user.company.name,
        users: payload,
      },
      onSuccess: () => {
        setPage(page + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    if (payload.length > 0) {
      dispatch(addUsersOnboarding(request));
    }
  };

  /* --------------------------- API calling for slide 6 ------------------------- */
  const handle_slide_6_data = (slide_6_payload) => {
    const payloadArr = [];
    slide_6_payload.map((item) => {
      item.activity_id.department = item.team_name;
      item.activity_id.user = item.user_name ? item.user_name : null;
      payloadArr.push(item.activity_id);
    });
    const request = {
      body: {
        activities: payloadArr,
      },
      onSuccess: () => {
        setPage(page + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    if (payloadArr.length > 0) {
      dispatch(addToDoOnboarding(request));
    }
  };

  /* --------------------------- API calling for slide 7 ------------------------- */
  const handle_slide_7_data = (slide_7_payload) => {
    const payload = [];
    slide_7_payload.map((asset) => {
      const obj = {
        asset_type: asset.asset_type,
        asset_type_option: asset.asset_type_Option.label,
        validation_id: asset.asset_type_Option.value,
      };
      payload.push(obj);
    });
    const request = {
      body: {
        assets: payload,
      },
      onSuccess: () => {
        setPage(page + 1);
        completeOnboarding();
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    if (payload.length > 0) {
      dispatch(addAssetsOnboarding(request));
    }
  };

  /*------------------------- API calling for slide 8 to complete onboarding ------------------ */
  const completeOnboarding = () => {
    const request = {
      body: {
        company_id: user.company.id,
        user_id: user.id,
      },
      onSuccess: () => {
        // const authUserData = {...user};
        // authUserData.is_board_complete = true
        // dispatch({type: LOGIN, payload: authUserData})
        setPage(page + 1);
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(completeOnboardingProcess(request));
  };

  return (
    <>
      <div
        className="h-screen"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(" +
            Image +
            ")",
          backgroundSize: "cover",
        }}
      ></div>
      <div className="absolute top-0 w-full h-full backdrop-blur-sm flex justify-center items-center">
        <div className="w-full md:w-3/4  bg-white rounded-3xl shadow-md max-h-3/5 md:h-3/4 static md:absolute">
          {page === 1 && <OnboardingSlide1 page={page} setPage={setPage} />}
          {page === 2 && (
            <OnboardingSlide2
              formik={formik_for_slide_2}
              setErrorForSlide2={setErrorForSlide2}
              errorForSlide2={errorForSlide2}
            />
          )}
          {page === 3 && (
            <OnboardingSlide3
              page={page}
              formik={formik_for_slide_3}
              errorForSlide3BusinessType={errorForSlide3BusinessType}
              errorForSlide3Country={errorForSlide3Country}
              setErrorForSlide3BusinessType={setErrorForSlide3BusinessType}
              setErrorForSlide3Country={setErrorForSlide3Country}
              SeterrorForSlide3Gst_number={SeterrorForSlide3Gst_number}
              errorForSlide3Gst_number={errorForSlide3Gst_number}
            />
          )}
          {page === 4 && (
            <OnboardingSlide4
              formik={formik_for_slide_4}
              FieldArray={FieldArray}
              FormikProvider={FormikProvider}
              Form={Form}
              errorForSlide4={errorForSlide4}
              setErrorForSlide4={setErrorForSlide4}
            />
          )}
          {page === 5 && (
            <OnboardingSlide5
              formik={formik_for_slide_5}
              FieldArray={FieldArray}
              FormikProvider={FormikProvider}
              Form={Form}
              page={page}
              errorForSlide5={errorForSlide5}
              setErrorForSlide5={setErrorForSlide5}
            />
          )}
          {page === 6 && (
            <OnboardingSlide6
              page={page}
              setPage={setPage}
              formik={formik_for_slide_6}
              FieldArray={FieldArray}
              FormikProvider={FormikProvider}
              Form={Form}
              addRemoveElement={addRemoveElement}
              setActivityData={setActivityData}
              errorForSlide6={errorForSlide6}
              setErrorForSlide6={setErrorForSlide6}
            />
          )}
          {/* {page === 7 && (
            <OnboardingSlide7
              formik={formik_for_slide_7}
              FieldArray={FieldArray}
              FormikProvider={FormikProvider}
              Form={Form}
              errorForSlide7={errorForSlide7}
              setErrorForSlide7={setErrorForSlide7}
              page={page}
            />
          )} */}
          {page === 7 && (
            <OnboardingSlide8
              page={page}
              setPage={setPage}
              completeOnboarding={completeOnboarding}
            />
          )}
          {
            page === 8 && (
              <OnboardingSlide9 />
            )
          }

          {
            page !== 8 && (
              <OnboadingFooter
                page={page}
                setPage={setPage}
                handleSubmit={send_formik_handleSubmit}
                handlePreviousButtonClick={handlePreviousButtonClick}
                completeOnboarding={completeOnboarding}
              />
            )
          }
          
        </div>
      </div>
    </>
  );
}

Onboading.auth = { path: "/onboard", role: "super-admin" };
